<template>
  <Modal
    ref="validateSessionDetailsModal"
    :title="'Session Details'"
    :width="'100%'"
    :height="'100%'"
    @closed="clearData"
  >
    <!-- <template #modal-header /> -->
    <template #modal-main>
      <div class="sessions">
        <HelpTip>
          To validate this model, click the "VALIDATE" button.
        </HelpTip>

        <div class="tab-selector">
          <input
            id="option-model-params"
            v-model="tab"
            type="radio"
            name="tab-selector"
            :value="'model-params'"
          >
          <label for="option-model-params">Model Parameters---</label>
          <!-- <input
              id="option-params"
              v-model="tab"
              type="radio"
              name="tab-selector"
              :value="'params'"
            >
            <label for="option-params">Parameters</label> -->
          <input
            id="option-metrics"
            v-model="tab"
            type="radio"
            name="tab-selector"
            :value="'metrics'"
          >
          <label for="option-metrics">Metrics</label>
          <input
            id="option-logs"
            v-model="tab"
            type="radio"
            name="tab-selector"
            :value="'logs'"
          >
          <label for="option-logs">System Logs</label>
        </div>
        <div v-if="tab==='model-params'" class="params">
          <Tooltip :placement="'top-start'" :trigger="'click'">
            <template #body>
              <pre>Model Parameters copied</pre>
            </template>
            <IconButton
              class="copy-params-icon"
              :icon="'copy'"
              :width="24"
              :height="24"
              :title="`Copy Parameters`"
              :type="'click'"
              @click.stop="copyToClipboard(model_parameters)"
            />
          </Tooltip>
          <ShikiHighlight
            class="model-params scrollbar shiki-model-params"
            :code="model_parameters"
            lang="yaml"
            theme="vitesse-dark"
          />
        </div>
        <div v-else-if="tab==='metrics'" class="metrics">
          <Tooltip :placement="'top-start'" :trigger="'click'">
            <template #body>
              <pre>Model Parameters copied</pre>
            </template>
            <IconButton
              class="copy-params-icon"
              :icon="'copy'"
              :width="24"
              :height="24"
              :title="`Copy Parameters`"
              :type="'click'"
              @click.stop="copyToClipboard(metrics)"
            />
          </Tooltip>
          <ShikiHighlight
            class="model-params scrollbar shiki-model-params"
            :code="metrics"
            lang="yaml"
            theme="vitesse-dark"
          />
        </div>
        <div v-else-if="tab==='logs'" class="system-logs">
          <div id="validate-session-system-logs" class="text-area-box scrollbar">
            <span><pre>{{ logs }}</pre></span>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import Modal from '@/components/Modal.vue';
import * as YAML from 'yaml';
import IconButton from '@/components/IconButton.vue';
import Tooltip from "@/components/Tooltip.vue";
import ShikiHighlight from "@/components/ShikiHighlight.vue";
import HelpTip from '../HelpTip.vue';
import { copyToClipboard as safeCopy } from '@/utils/clipboard';

export default {
  name: 'ValidateSessionDetailsModal',
  components: {
    Modal,
    IconButton,
    Tooltip,
    ShikiHighlight,
    HelpTip,
  },
  props: {
    session: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['stop-validate', 'delete-session'],
  data() {
    return {
      tab: 'model-params',
      internalSession: null,
      logs: null,
      show_menu: false,
    };
  },
  computed: {
    currentProject() {
      return this.$store.state.projects.currentProject;
    },
    model_parameters() {
      const YAMLfile = YAML.stringify(this.internalSession?.params.model_params, { indent: 8 });
      return YAMLfile;
    },
    metrics() {
      const YAMLfile = YAML.stringify(this.internalSession?.results, { indent: 8 });
      return YAMLfile;
    },
  },
  watch: {
    session: {
      deep: true,
      immediate: true,
      handler(newval, old) {
        if (newval) {
          this.internalSession = newval;
          this.getLogs();
        }
      },
    },
  },
  beforeUnmount() {
    this.clearData();
  },
  created() {
    this.dataConnect = new DatastoreConnect(this.$store.state.enterpriseServerUrl);
  },
  methods: {
    copyToClipboard(text) {
      safeCopy(text);
    },
    async showModal() {
      this.$refs.validateSessionDetailsModal.showModal();
    },
    closeModal() {
      this.clearData();
      this.$refs.validateSessionDetailsModal.closeModal();
    },
    clearData() {
      // this.selectedSessionAvailableFiles = null;
      // this.internalSession = null;
      this.tab = 'model-params';
    },
    async getLogs() {
      if (this.internalSession && this.internalSession.id) {
        const resp = await this.dataConnect.getValidateSessionLogs({
          validate_session_id: this.internalSession.id,
        });
        let temp = "";
        if (!resp || resp.error || !resp.result) {
          temp += `Validator may take some time to create logs file.`;
        } else {
          temp += resp.result;
        }

        this.logs = temp;
      } else {
        this.logs = null;
      }
    },
  },
};

</script>

<style lang="scss" scoped>

.sessions {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 100%;
  width: 100%;
  padding: 16px;

  ul {
    list-style-type: none;
  }
  .session-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .icon-container {
    display: flex;
    align-items: center;
      @include themify() {
        color: themed('body-text-color-secondary');
      }
      .icon + .icon {
        margin-left: 10px;
      }
    }
  }

  h3 {
    margin: 0;
    margin-bottom: 10px;
    font-size: 1rem;
    text-align: left;
    @include themify() {
      color: themed('body-text-color-secondary');
    }
  }

  &__body-row {
    display: flex;
    flex: 1 1 auto;
    margin-top: 5px;
    align-items: center;
  }

  .text-area-box {
    display: flex;
    flex-direction: row;
    border-radius: 4px;
    background: #121212;
    border: 1px solid grey;
    height: 100%;
    padding: 15px;
    overflow-y: auto;

    span {
      color: white;
      font-weight: 700;
      font-size: 0.9rem;

      pre {
        font-family: 'Courier New', monospace !important;
        text-align: left;
      }
    }
  }

  .text-area-details-white {
    display: grid;
    grid-template-columns: repeat(auto-fit, 450px);
    grid-auto-rows: 50px;
    grid-gap: 20px 5px;
    height: 100%;
    border-radius: 4px;
    background: var(--color-white-100);
    border: 1px solid var(--color-primary-100);
    padding: 15px;
    overflow-y: auto;

    .list-item {
      height: fit-content;
      display: flex;
      flex-direction: column;
      text-align: left;
      padding: 5px;

      label {
        @include themify() {
          color: tint-color(themed('body-text-color-secondary'), 20%);
        }
        font-weight: 700;
        font-size: 0.9rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      span {
        @include themify() {
          color: themed('body-text-color');
        }
        font-weight: 600;
        font-size: 0.9rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  .system-logs, .metrics, .params {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
  }

  .copy-params-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1000;
    color: var(--color-white-800)
  }
}

.model-params {
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 4px;
  background: var(--color-white-100);
  border: 1px solid var(--color-primary-100);
  overflow-y: auto;
}

.top {
  min-height: fit-content;
}

.bottom {
  overflow-y: auto;
}

._disabled {
  @include themify() {
    background: themed('color-disabled-100') !important;
    color: white;
    cursor: not-allowed !important;
    pointer-events: none;
    border: 1px solid transparent !important;
  }
}

.has-file {
  background: tint-color($color-success, 80%) !important;
}

.separator {
  display: flex;
  align-items: center;
  text-align: center;
  font-weight: 700;
  font-size: 0.75rem;
  @include themify() {
    color: themed('form-separator-color');
    border-color: themed('form-separator-color');
  }
  &::before, &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid;
  }
  &:not(:empty)::before {
    margin-right: 1.5em;
    margin-left: .25em;
  }
  &:not(:empty)::after {
    margin-right: .25em;
    margin-left: 1.5em;
  }
}

._selected {
  @include themify() {
    border: solid 1px themed('color-primary');
    background: rgba(themed('color-primary'), 0.2);
  }
}

hr.vr {
  display: flex;
  width: 1px;
  height: 60%;
  margin: 0;
}

a {
  text-decoration:none;
}
a + button {
  margin-left: 10px;
}

.tab-selector {
  display: flex;
  flex-direction: row;
}

.tab-selector input[type="radio"] {
  display: none;
}

.tab-selector label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  height: 32px;
  width: fit-content;
  font-size: 0.9rem;
  font-weight: bold;
  color: var(--body-text-color-heading);
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
}

.tab-selector input[type="radio"]:checked+label {
  @include themify() {
    color: themed('color-primary-500');
    border-bottom: 2px solid themed('color-primary-500');
  }
}

.shiki-model-params {
  text-align: left;
  white-space: pre-wrap;
}

:deep(.shiki-model-params pre) {
  padding: 16px;
  flex: 1 1 auto;
}

</style>
